import service from 'src/utils/request';

// 匿名登录
export async function anonymousLogin () {
  return await service({
    url: '/v1/user/freeLogin',
    method: 'get'
  });
}
